import { apiClient, type components } from '@boothiva/api-client';

export type Device = components['schemas']['DeviceResponse'];
export type DevicePage = components['schemas']['DevicePage'];
export type CreateDeviceRequest = components['schemas']['CreateDeviceRequest'];
export type UpdateDeviceRequest = components['schemas']['UpdateDeviceRequest'];
export type ActivationCode = components['schemas']['IssueActivationCodeResponse'];

export type DeviceFilters = { page: number; pageSize: number; q?: string; status?: string; sort?: string };

export function listDevices(filters: DeviceFilters) {
  const query = new URLSearchParams({ page: String(filters.page), pageSize: String(filters.pageSize) });
  if (filters.q) query.set('q', filters.q);
  if (filters.status) query.set('status', filters.status);
  if (filters.sort) query.set('sort', filters.sort);
  return apiClient.get<DevicePage>(`/api/v1/devices?${query}`);
}

export const getDevice = (id: string) => apiClient.get<Device>(`/api/v1/devices/${id}`);
export const createDevice = (request: CreateDeviceRequest) => apiClient.post<Device>('/api/v1/devices', request);
export const updateDevice = (id: string, request: UpdateDeviceRequest) => apiClient.put<Device>(`/api/v1/devices/${id}`, request);
export const deleteDevice = (id: string) => apiClient.delete<void>(`/api/v1/devices/${id}`);
export type DeviceDiagnosticsBundle = components['schemas']['DeviceDiagnosticsBundleResponse'];
export type DeviceDiagnosticsDownload = components['schemas']['DeviceDiagnosticsDownloadResponse'];

export type ResetDevicePinRequest = components['schemas']['ResetDevicePinRequest'];

export type DevicePinStatus = components['schemas']['DevicePinStatusResponse'];

export const getDevicePinStatus = (id: string) =>
  apiClient.get<DevicePinStatus>(`/api/v1/devices/${id}/pin`);

export const resetDevicePin = (id: string, request: ResetDevicePinRequest) =>
  apiClient.post<void>(`/api/v1/devices/${id}/pin/reset`, request);

export const requestDeviceDiagnostics = (id: string) =>
  apiClient.post<void>(`/api/v1/devices/${id}/diagnostics/request`);
export const listDeviceDiagnostics = (id: string) =>
  apiClient.get<DeviceDiagnosticsBundle[]>(`/api/v1/devices/${id}/diagnostics`);
export const getDeviceDiagnosticsDownload = (id: string, bundleId: string) =>
  apiClient.get<DeviceDiagnosticsDownload>(`/api/v1/devices/${id}/diagnostics/${bundleId}/download`);

export const issueActivationCode = (id: string) => apiClient.post<ActivationCode>(`/api/v1/devices/${id}/activation-code`);

/** Unpairs a booth. `revoke: false` returns it to pending activation so it can be paired again;
 *  `revoke: true` is the terminal path for lost or stolen hardware. */
export const resetDevice = (id: string, revoke = false) =>
  apiClient.post<void>(`/api/v1/devices/${id}/reset`, { revoke });
